/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Ai_Chat_Steps_ExpandInputs */

const en_admin_ai_chat_steps_expand = /** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expand ${i?.count} earlier steps`)
};

const de_admin_ai_chat_steps_expand = /** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} frühere Schritte ausklappen`)
};

const es_admin_ai_chat_steps_expand = /** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mostrar ${i?.count} pasos anteriores`)
};

const fr_admin_ai_chat_steps_expand = /** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Afficher ${i?.count} étapes précédentes`)
};

const nl_admin_ai_chat_steps_expand = /** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} eerdere stappen uitvouwen`)
};

/** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */
const it_admin_ai_chat_steps_expand = en_admin_ai_chat_steps_expand;

/** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_steps_expand = en_admin_ai_chat_steps_expand;

/** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */
const pl_admin_ai_chat_steps_expand = en_admin_ai_chat_steps_expand;

/** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */
const hu_admin_ai_chat_steps_expand = en_admin_ai_chat_steps_expand;

/** @type {(inputs: Admin_Ai_Chat_Steps_ExpandInputs) => LocalizedString} */
const ro_admin_ai_chat_steps_expand = en_admin_ai_chat_steps_expand;

/**
* | output |
* | --- |
* | "Expand {count} earlier steps" |
*
* @param {Admin_Ai_Chat_Steps_ExpandInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_steps_expand = /** @type {((inputs: Admin_Ai_Chat_Steps_ExpandInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Steps_ExpandInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_steps_expand(inputs)
	if (locale === "de") return de_admin_ai_chat_steps_expand(inputs)
	if (locale === "es") return es_admin_ai_chat_steps_expand(inputs)
	if (locale === "fr") return fr_admin_ai_chat_steps_expand(inputs)
	if (locale === "nl") return nl_admin_ai_chat_steps_expand(inputs)
	if (locale === "it") return it_admin_ai_chat_steps_expand(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_steps_expand(inputs)
	if (locale === "pl") return pl_admin_ai_chat_steps_expand(inputs)
	if (locale === "hu") return hu_admin_ai_chat_steps_expand(inputs)
	return ro_admin_ai_chat_steps_expand(inputs)
});
export { admin_ai_chat_steps_expand as "admin.ai_chat.steps_expand" }